module.exports = __webpack_public_path__ + "img/V20.2a1a0ec7.png";